import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface NavItem {
  path: string;
  label: string;
  emoji: string;
}

// All available pages (excluding "Neu" which is fixed)
export const ALL_NAV_OPTIONS: NavItem[] = [
  { path: '/', label: 'Home', emoji: '\uD83C\uDFE0' },
  { path: '/receipts', label: 'Belege', emoji: '\uD83E\uDDFE' },
  { path: '/shopping-list', label: 'Liste', emoji: '\uD83D\uDED2' },
  { path: '/todos', label: 'Aufgaben', emoji: '\u2611\uFE0F' },
  { path: '/stats', label: 'Stats', emoji: '\uD83D\uDCC8' },
  { path: '/recurring', label: 'Fixkosten', emoji: '\uD83D\uDD04' },
  { path: '/prices', label: 'Preise', emoji: '\uD83D\uDCB0' },
  { path: '/quick-entry', label: 'Schnell', emoji: '\u270F\uFE0F' },
  { path: '/settings', label: 'Einstellungen', emoji: '\u2699\uFE0F' },
];

// Fixed center item
export const NEU_ITEM: NavItem & { highlight: true } = {
  path: '/receipts/new',
  label: 'Neu',
  emoji: '\u2795',
  highlight: true,
};

// Default slots: [left1, left2, CENTER=Neu, right1, right2]
const DEFAULT_SLOTS: [string, string, string, string] = [
  '/',
  '/receipts',
  '/shopping-list',
  '/stats',
];

interface BottomNavState {
  slots: [string, string, string, string]; // 4 customizable slots around fixed center
  setSlot: (index: number, path: string) => void;
  resetSlots: () => void;
}

export const useBottomNavStore = create<BottomNavState>()(
  persist(
    (set) => ({
      slots: DEFAULT_SLOTS,
      setSlot: (index, path) =>
        set((state) => {
          const newSlots = [...state.slots] as [string, string, string, string];
          // If this path is already in another slot, swap them
          const existingIndex = newSlots.indexOf(path);
          if (existingIndex !== -1 && existingIndex !== index) {
            newSlots[existingIndex] = newSlots[index];
          }
          newSlots[index] = path;
          return { slots: newSlots };
        }),
      resetSlots: () => set({ slots: DEFAULT_SLOTS }),
    }),
    {
      name: 'paarkurs-bottom-nav',
    }
  )
);
